import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-busy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_error_message = _resolveComponent("error-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: "loading-container",
    "aria-live": "polite",
    "aria-busy": _ctx.state === 'loading'
  }, [
    (_ctx.state === 'loading')
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          size: _ctx.size
        }, null, 8, ["size"]))
      : _createCommentVNode("", true),
    (_ctx.state === 'error')
      ? (_openBlock(), _createBlock(_component_error_message, {
          key: 1,
          msg: _ctx.errormsg
        }, null, 8, ["msg"]))
      : _createCommentVNode("", true),
    (_ctx.state === 'success')
      ? _renderSlot(_ctx.$slots, "default", {}, undefined, true, 2)
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}